import TimeframeFilter from './TimeframeFilter.component';

export default TimeframeFilter;
